import { MotionMasterMessage } from './types';

export const parameterValueTypeOptions = {
  intValue: 'intValue',
  uintValue: 'uintValue',
  floatValue: 'floatValue',
  stringValue: 'stringValue',
  rawValue: 'rawValue',
};

export const ethercatNetworkStateOptions = MotionMasterMessage.Status.EthercatNetworkState.State;
export const positionControllerTypeOptions =
  MotionMasterMessage.Request.ComputeAutoTuningGains.PositionParameters.ControllerType;
